// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2l3Hl","modalFooterButton":"ModalNotes_modalFooterButton__1s4OC"};